initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});

$(document).on('shopify:section:unload', function(event) {
  initslide();
});

function initslide() {
  $('.M-trustpilot-slider').slick({
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 575,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
function initializeSlider(){
var swiper = new Swiper(".mySwiper", {
  slidesPerView: 3,
  spaceBetween: 48,  
  scrollbar: {
    el: ".swiper-scrollbar",
  },
    breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    569: {
      slidesPerView: 1.3,
      spaceBetween: 20,
    },
    348: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
  }

});
}

function servicesSlider() {
    $('.M-services-slider').slick({
     infinite: false,
     speed: 300,
     slidesToShow: 4,
     slidesToScroll: 1,
     arrows: false,
     responsive: [
       {
         breakpoint: 1200,
         settings: {
           slidesToShow: 3,
           dots: true
         }
       }, 
       {
         breakpoint: 991,
         settings: {
           slidesToShow: 2,
           dots: true
         }
       },
         {
         breakpoint: 767,
         settings: {
           slidesToShow: 1,
           dots: true
         }
       }
     ]
   });
 }